import React from 'react';
import TwitterCarousel from './components/twitter-carousel';
import TwitterCarouselTitle from './components/twitter-carousel-title';
import { StyledCarouselWrapper } from './components/twitter-carousel/styled';
import { useFeatureAppContent } from './hooks/use-feature-app-content';

export interface AppProps {
  readonly baseUrl?: string;
}

// @ts-ignore
export function App(props): JSX.Element | null {
  const { titleText } = useFeatureAppContent();
  return (
    <StyledCarouselWrapper>
      <TwitterCarouselTitle titleText={titleText} />
      <TwitterCarousel />
    </StyledCarouselWrapper>
  );
}
